import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AnalyticService } from 'app/analytic/analytic.service';
import { ApiService } from 'app/modules/shared/services/api.service';
import * as _ from 'underscore';
import { HighchartsComponent } from 'app/modules/shared/highcharts/highcharts.component';
import { UsageAnalytics } from '../../analytic/graph-tab-data-analytics/UsageAnalytics';

@Component({
  selector: 'app-stars-lessons-usage-graph-analtics',
  templateUrl: './stars-lessons-usage-graph-analtics.component.html',
  styleUrls: ['./stars-lessons-usage-graph-analtics.component.scss']
})
export class StarsLessonsUsageGraphAnalticsComponent implements OnInit {
  @ViewChild(HighchartsComponent, { static: false }) highchartsComponent: HighchartsComponent;
  @Input() height = '400px';
  @Input() marginTop = '20px';
  @Input() maximumPoints = 15;
  @Input() seriesType = 'spline';

  @Input() sessionPlayedChartDatasets: Array<any> = [];
  @Input() sessionPlayedChartLabels: Array<any> = [];
  @Input() selectedApp: any;
  @Input() menuSelectedButton: any;
  @Input() listDateRange: any;
  @Output() emitAnalytics = new EventEmitter();
  @Output() exportCsvEvent = new EventEmitter();
  @Input() updateChart = false;
  @Input() userName: string;
  
  usageAnalyticsSelectedValue: string = 'all';  
  
  usageAnalytics: UsageAnalytics[] = [
    { viewValue: 'All', value: 'all' },
    { viewValue: 'Total Sessions', value: 'totalSessionPlayed' },
    { viewValue: 'Average Session Duration', value: 'totalSessionDurationAvg' },    
    { viewValue: 'Users', value: 'totalUsers' }
  ];

  usageUserAnalytics: UsageAnalytics[] = [
    { viewValue: 'All', value: 'all' },
    { viewValue: 'Total Sessions', value: 'totalSessionPlayed' },
    { viewValue: 'Average Session Duration', value: 'totalSessionDurationAvg' }
  ];

  constructor(public analyticService: AnalyticService,
    public api: ApiService) { 
    }

  ngOnInit() {
    if (this.userName) {
      this.usageAnalytics = this.usageUserAnalytics;
    }
  }

  ngOnChanges() {
  } 

  changeAnalytics(value) {
    this.emitAnalytics.emit(value);
  }

  exportCsvData(data){
    this.exportCsvEvent.emit(data);
  }

  updateChartData(label: string[], dataset: any) {
    this.highchartsComponent.updateChartData(label, dataset);
  }

}
